/**
 * Scalar helpers ported verbatim from the concept renderer (concept L11–L25).
 * Tests compare them bit for bit against the original.
 */

export const PERIOD = 800; // world repeats every 800 m (GDD §3.3, concept L8)

export function clamp(x: number, a: number, b: number): number {
  return x < a ? a : x > b ? b : x;
}

export function sstep(a: number, b: number, x: number): number {
  const t = clamp((x - a) / (b - a), 0, 1);
  return t * t * (3 - 2 * t);
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function fract(x: number): number {
  return x - Math.floor(x);
}

/** Frame-rate independent exponential approach of `a` toward `b` at rate `k` per second. */
export function damp(a: number, b: number, k: number, dt: number): number {
  return lerp(a, b, 1 - Math.exp(-k * dt));
}

/** Wraps a z offset into (−period/2, period/2]. */
export function wrapDz(dz: number, period = PERIOD): number {
  dz = ((dz % period) + period) % period;
  return dz > period / 2 ? dz - period : dz;
}
